module.exports = __webpack_public_path__ + "static/img/groundworks.92f858f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/groundworks.jpg
// module id = xamQ
// module chunks = 0